<div class="privacy-policy" id="privacy-policy">
  <div class="container">
    <div class="col-12 offset-xl-3 col-xl-6 offset-xl-3">
      <h3 class="privacy-policy__header">What are cookies</h3>
      <p class="privacy-policy__parahraph _1r">
        As is common practice with almost all professional websites this site
        uses cookies, which are tiny files that are downloaded to your computer,
        to improve your experience. This page describes what information they
        gather, how we use it and why we sometimes need to store these cookies.
        We will also share how you can prevent these cookies from being stored
        however this may downgrade or ‘break’ certain elements of the sites
        functionality.For more general information on cookies see the Wikipedia
        article on HTTP Cookies.
      </p>
      <h3 class="privacy-policy__header">How we use cookies</h3>
      <p class="privacy-policy__parahraph _1r">
        We use cookies for a variety of reasons detailed below. Unfortunately in
        most cases there are no industry standard options for disabling cookies
        without completely disabling the functionality and features they add to
        this site. It is recommended that you leave on all cookies if you are
        not sure whether you need them or not in case they are used to provide a
        service that you use.
      </p>
      <h3 class="privacy-policy__header">Disabling cookies</h3>
      <p class="privacy-policy__parahraph _1r">
        You can prevent the setting of cookies by adjusting the settings on your
        browser (see your browser Help for how to do this). Be aware that
        disabling cookies will affect the functionality of this and many other
        websites that you visit. Disabling cookies will usually result in also
        disabling certain functionality and features of the this site. Therefore
        it is recommended that you do not disable cookies.
      </p>
      <h3 class="privacy-policy__header">The Cookies We Set</h3>
      <p class="privacy-policy__parahraph _1r">
        Forms related cookiesWhen you submit data to through a form such as
        those found on contact pages or comment forms cookies may be set to
        remember your user details for future correspondence.
      </p>
      <h3 class="privacy-policy__header">Third Party Cookies</h3>
      <p class="privacy-policy__parahraph _1r">
        In some special cases we also use cookies provided by trusted third
        parties. The following section details which third party cookies you
        might encounter through this site.Types of cookies we use:
      </p>
      <ul>
        <li class="_1r">
          Necessary Cookies – necessary cookies help make a website usable by
          enabling basic functions like page navigation and access to secure
          areas of the website. The website cannot function properly without
          these cookies.
        </li>
        <li class="_1r">
          Anonymous statistic cookies – statistic cookies help website owners to
          understand how visitors interact with websites by collecting and
          reporting information anonymously.
        </li>
        <li class="_1r">
          Marketing and Ads – marketing cookies are used to track visitors
          across websites. The intention is to display ads that are relevant and
          engaging for the individual user and thereby more valuable for
          publishers and third party advertisers.
        </li>
      </ul>
      <h3 class="privacy-policy__header">More information</h3>
      <p class="privacy-policy__parahraph _1r">
        Hopefully that has clarified things for you and as was previously
        mentioned if there is something that you aren’t sure whether you need or
        not it’s usually safer to leave cookies enabled in case it does interact
        with one of the features you use on our site. This Cookies Policy was
        created with the help of the Generator of GDPR Cookies Policy Template
        and the GDPR Cookies Policy Template based on the Privacy Policy
        Generator from TermsFeed.However if you are still looking for more
        information then you can contact us through one of our preferred contact
        methods:
      </p>
      <div class="privacy-policy__contact">
        <p class="m-0 display display-4r">Email: info&#64;niceproject.com</p>
        <p class="m-0 display display-4r">By visiting this link:</p>
        <p class="m-0 display display-4r">https://niceproject.com/contact/</p>
        <p class="m-0 display display-4r">Phone: +48 123 456 789</p>
      </div>
    </div>
  </div>
</div>
